import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

// My Files
import { UserContext } from "../../../context";
import UserAvatar from "../UserAvatar";
import firebase from "../../../firebase";

export default function DuplicateUserDialog(props) {
    const { currentUserData } = useContext(UserContext);
    const history = useHistory();

    function handleBecomeAdminPress() {
        let userAdminsObject = {};

        props.user.admins.forEach((adminKey) => {
            userAdminsObject[adminKey] = true;
        });

        userAdminsObject[currentUserData.key] = true;

        let userRef = firebase.database().ref("users").child(props.user.key);
        userRef.update({ admins: userAdminsObject });
        props.onSuccess?.();
        history.replace("manageuser/" + props.user.key);
    }

    return (
        <Dialog
            onClose={props.onClose}
            open={props.open}
            aria-labelledby="duplicate-user-dialog-title"
            fullWidth
            maxWidth="sm"
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 3,
                        overflow: "hidden",
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        color: "primary.main",
                        backgroundColor: "action.hover",
                    }}
                >
                    <PersonSearchOutlinedIcon />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        id="duplicate-user-dialog-title"
                        variant="h5"
                        component="h2"
                        sx={{ lineHeight: 1.1 }}
                    >
                        User already exists
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}
                    >
                        This email address is already linked to an account.
                    </Typography>
                </Box>
                <IconButton
                    aria-label="Close duplicate user"
                    onClick={props.onClose}
                    sx={{ mt: -0.75, mr: -1 }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent
                dividers
                sx={{
                    p: { xs: 2, sm: 2.5 },
                    backgroundColor: "background.default",
                }}
            >
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1.5 }}
                >
                    The email address <strong>{props.user.email}</strong> is
                    already used by:
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.75,
                        p: 2,
                        borderRadius: 2.5,
                        border: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.paper",
                    }}
                >
                    <UserAvatar
                        userOrHub={props.user}
                        path="users"
                        variant="circular"
                        size="large"
                    />
                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 800 }}
                        >
                            {props.user.firstName + " " + props.user.lastName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {props.user.customRoleName}
                        </Typography>
                    </Box>
                </Box>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1.5, lineHeight: 1.55 }}
                >
                    If this is the person you intended to add, become an
                    administrator of their existing account instead.
                </Typography>
            </DialogContent>

            <DialogActions
                sx={{
                    px: { xs: 2, sm: 3 },
                    py: 1.5,
                    flexWrap: "wrap",
                    gap: 0.5,
                }}
            >
                <Button onClick={props.onClose} color="inherit">
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    disableElevation
                    startIcon={<AdminPanelSettingsOutlinedIcon />}
                    onClick={handleBecomeAdminPress}
                >
                    Become administrator
                </Button>
            </DialogActions>
        </Dialog>
    );
}
